import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainApp from './MainApp';
import ClientLocationPage from './components/pages/ClientLocationPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';

export default function App() {
    // --- PUBLIC ROUTES HANDLING ---
    // Handle the public /locate/ route early to avoid loading heavy dashboard data
    // or requiring authentication.
    if (window.location.pathname.startsWith('/locate/')) {
        return (
            <Router>
                <Routes>
                    <Route path="/locate/:sessionId" element={<ClientLocationPage />} />
                </Routes>
            </Router>
        );
    }

    if (window.location.pathname === '/privacidade') {
        return (
            <Router>
                <Routes>
                    <Route path="/privacidade" element={<PrivacyPolicyPage />} />
                </Routes>
            </Router>
        );
    }

    // Default to the main authenticated application
    return <MainApp />;
}
